import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { LOCALIZATION } from "../../utils/localization";
import { orderType } from "../../utils/Constants";
import { useNavigate } from "react-router-dom";

interface BookingDateConfirmDialogProps {
  open: boolean;
  bookingDate: string;
  newDate: string;
  onConfirm: () => void;
  onCancel: () => void;
  type: any;
}

const BookingDateConfirmDialog: React.FC<BookingDateConfirmDialogProps> = ({
  open,
  bookingDate,
  newDate,
  onConfirm,
  onCancel,
  type,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const displayDateFormat = (date: string) =>
    new Date(date).toLocaleDateString();
  const hasFutureDate = Boolean(newDate);
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        {hasFutureDate ? t(LOCALIZATION.Confirmation) : t(LOCALIZATION.caution)}
      </DialogTitle>
      <DialogContent>
        <Typography>
          {hasFutureDate ? (
            t(LOCALIZATION.bookingDateUnavailable, {
              bookingDate: displayDateFormat(bookingDate),
              newDate: displayDateFormat(newDate),
            })
          ) : (
            <Trans
              i18nKey={LOCALIZATION.pujaDatePassed}
              values={{
                type:
                  type === orderType.chadhava
                    ? t(LOCALIZATION.Chadhava)
                    : t(LOCALIZATION.Puja),
                expiredDate: displayDateFormat(bookingDate),
              }}
              components={{
                bold: <span style={{ fontWeight: 600 }} />,
              }}
            />
          )}
        </Typography>
      </DialogContent>
      <DialogActions>
        {!hasFutureDate && (
          <Button onClick={(e:any)=>{
            e.preventDefault();
             
            if(type === orderType.chadhava){
              navigate('/chadhavaTemples');
            }else{
              navigate('/pujas');
            }
          }} color="primary" variant="contained">
            <Trans
              i18nKey={
                type === orderType.chadhava
                  ? LOCALIZATION.explore_other_Chadhavas
                  : LOCALIZATION.explore_other_Pujas
              }
            />
          </Button>
        )}
        <Button onClick={onCancel}>
          {hasFutureDate ? t(LOCALIZATION.No) : t(LOCALIZATION.Close)}
        </Button>
        {hasFutureDate && (
          <Button onClick={onConfirm} color="primary" variant="contained">
            {t(LOCALIZATION.Yes)}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default BookingDateConfirmDialog;
